import React, { useState } from "react";
import { LogIn, Mail, Lock, X, Eye, EyeOff } from "lucide-react";
import SignUpForm from "./SignUpForm";
import ForgotPasswordForm from "./ForgotPasswordForm";
import Glogo from "./search (1).png";
import "./LoginForm.css";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { useAuth } from "../../../context/AuthContext";
import axios from "axios";
import { useEffect, useRef } from "react";
const LoginForm = ({ onClose, onLoginSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [formMode, setFormMode] = useState("login");

  const { login } = useAuth();

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      setIsLoading(true);
      setError("");
      const decoded = jwtDecode(credentialResponse.credential);
      console.log("Google Login Success:", decoded);

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/users/google-login`,
        { token: credentialResponse.credential },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true
        }
      );

      if (!response.data.accessToken) {
        throw new Error("No access token received");
      }

      // Update auth context
      login(response.data.accessToken, response.data.user);

      if (onLoginSuccess) {
        onLoginSuccess(response.data.user);
      }
      onClose();
    } catch (error) {
      console.error("Google Login Error:", error);
      setError(error.response?.data?.message || "Google login failed");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/users/userlogin`,
        { email, password },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (!response.data.accessToken) {
        throw new Error("No access token received");
      }

      console.log("Login successful:", response.data);

      // Update auth context
      login(response.data.accessToken, response.data.user);
      console.log("sessionStorage accessToken:", sessionStorage.getItem("accessToken"));
      console.log("document.cookie:", document.cookie);

      if (onLoginSuccess) {
        onLoginSuccess(response.data.user);
      }
      onClose();
    } catch (error) {
      console.error("Login error:", error);
      setError(error.response?.data?.message || "Login failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  if (formMode === "signup") {
    return <SignUpForm onClose={onClose} switchToLogin={() => setFormMode("login")} />;
  }

  if (formMode === "forgotPassword") {
    return <ForgotPasswordForm onClose={onClose} switchToLogin={() => setFormMode("login")} />;
  }

  return (
    <GoogleOAuthProvider clientId="286962317339-hlmfc2sat42blmu4dopc76jifu2tthns.apps.googleusercontent.com">
      <div className="login-overlay">
        <div className="login-modal">
          <button className="close-btn" onClick={onClose}>
            <X size={24} />
          </button>

          <div className="login-content">
            <div className="login-header">
              <LogIn size={40} className="circle-user" />
              <h2>Welcome Back</h2>
              <p>Please enter your credentials</p>
            </div>

            <form onSubmit={handleSubmit} className="login-form">
              {error && <div className="error-message">{error}</div>}

              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <div className="input-wrapper">
                  <Mail className="input-icon" size={20} />
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    required
                    disabled={isLoading}
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="password">Password</label>
                <div className="input-wrapper">
                  <Lock className="input-icon" size={20} />
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    required
                    disabled={isLoading}
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                    disabled={isLoading}
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
              </div>

              <div className="form-extras">
                <div className="remember-me">
                  <input
                    type="checkbox"
                    id="remember"
                    checked={rememberMe}
                    onChange={() => setRememberMe(!rememberMe)}
                    disabled={isLoading}
                  />
                  <label htmlFor="remember">Remember me</label>
                </div>
                <a
                  href="#"
                  className="forgot-password"
                  onClick={(e) => {
                    e.preventDefault();
                    setFormMode("forgotPassword");
                  }}
                >
                  Forgot Password?
                </a>
              </div>

              <button
                type="submit"
                className={`login-submit ${isLoading ? "loading" : ""}`}
                disabled={isLoading}
              >
                {isLoading ? "Logging In..." : "Log In"}
              </button>

              <div className="signup-link">
                Don't have an account?
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setFormMode("signup");
                  }}
                >
                  {" "}
                  Sign Up
                </a>
              </div>

              <div className="social-divider">
                <span>Or continue with</span>
              </div>

              <div className="social-logins">
                <GoogleLogin
                  onSuccess={handleGoogleSuccess}
                  onError={() => {
                    console.error("Google Login Failed");
                    setError("Google login failed");
                  }}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};

export default LoginForm;